<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14y6pYN/tc-custom/9781681888064.jpg?1705208137624" alt="This image is the cover for the book Dad Jokes: Hall of Shame"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dad Jokes: Hall of Shame
      </h1>
      <p class="bookDescription body article font2">
        <b>Over 1,000 gags and groaners to make you crack up and cringe at the same time!</b><br/><br/>From the creators of the popular humor website HowToBeADad.com, this is a collection of 1,000 of the most amusing—and most painful—Dad Jokes ever. Humor is often referred to as the best medicine, and this collection of Dad Jokes—guaranteed the most groan-and-forehead-slap-worthy on the market—offers a broad selection of humorous puns and quips. Organized by joke theme—from animals to holidays to technology—it includes more than a hundred illustrations, and even touches on some timely topics (“Because of the pandemic, they’re having to televise the World Origami Championship. It’s on paperview.”)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andy Herald
      </h2>
      
      <p class="authorDescription body article">Andy Herald is a freelancer graphic designer, social media maven, parent of three excellently-parented kids (just ask him!), and the co-founder of HowToBeADad.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldon Owen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7aae016c